export const colors = {
    black: '#010606',
    green: '#01BF71',
    grey: '#161616',
    lightGrey: '#F0F0F0',

    white: '#fff',
    red: '#F94C66',
}
